import {
    Box,
    Stack,
    Pagination,
    TextField,
    Button,
    alpha,
    styled,
} from '../../base';
import { TOP_HEADER_HEIGHT } from '../../common';

const CONTROL_HEIGHT = 44;

export const StyledPage = styled(Stack)(({ theme }) => ({
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
    overflow: 'hidden',
    padding: theme.spacing(3),
}));

export const StyledTopRow = styled(Stack)(({ theme }) => ({
    marginBottom: theme.spacing(1),
}));

export const StyledSearchField = styled(TextField)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: theme.palette.background.paper,
    },
    '& .MuiInputBase-sizeSmall.MuiOutlinedInput-root': {
        height: CONTROL_HEIGHT,
    },
}));

export const StyledFilterDropdown = styled(Box)(() => ({
    width: 210,
    '& > div': {
        minHeight: CONTROL_HEIGHT,
        height: CONTROL_HEIGHT,
    },
}));

export const StyledAddButton = styled(Button)(({ theme }) => ({
    height: CONTROL_HEIGHT,
    borderRadius: theme.spacing(3),
    paddingInline: theme.spacing(3),
    textTransform: 'none',
    fontWeight: 700,
    color: theme.palette.common.white,
    background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
    '&:hover': {
        background: `linear-gradient(180deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    },
}));

export const StyledGrid = styled(Box)(({ theme }) => ({
    flex: 1,
    minHeight: 0,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridAutoRows: '1fr',
    gap: theme.spacing(3),
    [theme.breakpoints.down('lg')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));

export const StyledFooter = styled(Stack)(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

export const StyledEmpty = styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8, 2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

export const StyledPagination = styled(Pagination)(({ theme }) => ({
    '& .MuiPaginationItem-root': {
        height: 40,
        width: 40,
        margin: theme.spacing(0, 0.5),
        borderRadius: theme.spacing(1),
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: 14,
    },
    '& .MuiPaginationItem-root.Mui-selected': {
        backgroundColor: alpha(theme.palette.primary.main, 0.18),
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
    },
    '& .MuiPaginationItem-root.Mui-selected:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.25),
    },
    '& .MuiPaginationItem-root:focus': {
        outline: 'none',
        boxShadow: 'none',
    },
}));
